import type { NavigationItem } from '@/types';

export const defaultNavItems: NavigationItem[] = [
  { id: 'home', label: 'Overview', icon: 'home', path: '/home' },
  {
    id: 'academy',
    label: 'Academy',
    icon: 'academy',
    path: '/academy',
    permissions: ['portal:academy:view', 'academy:view'],
  },
  {
    id: 'community',
    label: 'Community',
    icon: 'community',
    path: '/community',
    permissions: ['portal:community:view', 'community:view'],
  },
  {
    id: 'launchpad',
    label: 'Launchpad',
    icon: 'launchpad',
    path: '/launchpad',
    permissions: ['portal:launchpad:view', 'launchpad:view'],
  },
  {
    id: 'support',
    label: 'Support',
    icon: 'support',
    path: '/support',
    permissions: ['portal:support:view', 'support:view'],
  },
  {
    id: 'shop',
    label: 'Shop',
    icon: 'shop',
    path: '/shop',
    permissions: ['portal:shop:view', 'shop:view'],
  },
  {
    id: 'portfolio',
    label: 'Portfolio',
    icon: 'portfolio',
    path: '/portfolio',
    permissions: ['portal:portfolio:view', 'portfolio:view'],
  },
  {
    id: 'marketplace',
    label: 'Marketplace',
    icon: 'marketplace',
    path: '/marketplace',
    permissions: ['portal:marketplace:view'],
  },
  {
    id: 'library',
    label: 'Library',
    icon: 'library',
    path: '/library',
    permissions: ['portal:library:view', 'portal:library:partner', 'portal:library:admin'],
  },
  {
    id: 'booking',
    label: 'Booking',
    icon: 'booking',
    path: '/booking',
    permissions: ['portal:booking:view', 'portal:booking:action', 'portal:booking:admin'],
  },
];

export const serviceNavItemIds = defaultNavItems
  .filter((item) => item.id !== 'home')
  .map((item) => item.id);
